angular.module('leanlaw').controller('SummaryIndexController', ['$scope', '$filter', '$rootScope', '$q', '$stateParams', '$state', "alerts", "singleRequest", "clientManager", "matterManager", "lists", "messageBus", function ($scope, $filter, $rootScope, $q, $stateParams, $state, alerts, singleRequest, clientManager, matterManager, lists, messageBus) {
  $scope.activeTab = "overview";
  $scope.reportName = $stateParams.report;
  $scope.filter = {};
  loadClientMatter($stateParams.clientId, $stateParams.matterId);
  singleRequest.cancel("getclientmatter");
  singleRequest.cancel("getaccounting");
  singleRequest.cancel("usersummary");
  singleRequest.cancel("tabdetail-entries");
  singleRequest.cancel("tabdetail-expenses");
  singleRequest.cancel("tabdetail-charges");
  singleRequest.cancel("notbilled");
  singleRequest.cancel("invoices");
  singleRequest.cancel("payments");
  async function loadClientMatter(clientId, matterId) {
    if (matterId) {
      let matter = await matterManager.get(matterId);
      $scope.cm = {
        matter: matter,
        client: matter.client
      };
      $scope.billable = ['contingency', 'internal'].indexOf(matter.billing.type) < 0;
      $scope.cost = ['contingency', 'fixed'].indexOf(matter.billing.type) >= 0;
    } else if (clientId) {
      let client = await clientManager.get(clientId, {
        matters: 'include'
      });
      $scope.cm = {
        client: client
      };
      if (client.matters.length === 1) {
        $scope.cm.matter = client.matters[0];
      }
      $scope.billable = client.matters.find(m => ['contingency', 'internal'].indexOf(m.billing.type) < 0);
      $scope.cost = client.matters.find(m => ['contingency', 'fixed'].indexOf(m.billing.type) >= 0);
    }
    messageBus.addMessage("clientmatter-set", true, $scope.cm);
  }
  $scope.timePeriod = function () {
    var {
      range
    } = $scope.filter;
    var text = '';
    if (range.startDate) {
      text += $filter('datePretty')(range.startDate);
    }
    text += ' - ';
    text += $filter('datePretty')(range.endDate || new Date());
    return text;
  };
  $scope.matterType = () => {
    if ($scope.cm.matter) {
      return lists.billingTypeFromId($scope.cm.matter.billing.type);
    }
  };
  $scope.print = function () {
    window.print();
  };
  $scope.export = function () {
    // We need to communicate with ui-views, so we'll use events
    // with the suffix being the tab name
    $rootScope.$broadcast(`summary-export-${$scope.activeTab}`);
  };
  $scope.isActive = function (name) {
    return $scope.activeTab == name;
  };
  $scope.selectTab = function (name) {
    $scope.activeTab = name;
  };
  $scope.$on('commonFilterService-statechanged', (event, payload) => {
    if (!payload) return;
    // Assigning to existing filter keeps custom filter options
    $scope.filter = Object.assign($scope.filter, payload);
    // Necessary to set this value for the requests
    $scope.filter.status = $scope.filter.archived.status;
    $scope.filter.scope = $scope.filter.filter.scope;
  });
  $scope.$on("report-clientmatter-change", async (event, cm) => {
    var clientId = cm.client ? cm.client.id : undefined;
    var matterId = cm.matter ? cm.matter.id : undefined;
    if (!cm.client && !cm.matter) {
      return $state.go($stateParams.return || "reports");
    }
    $state.go('reports.client-summary', Object.assign($stateParams, {
      clientId,
      matterId
    }));
    await loadClientMatter(clientId, matterId);
    $rootScope.$broadcast("commonFilterService-statechanged");
  });
  $scope.$on("report-sidebar-filterchange", (event, payload) => {
    console.log("filter");
    $scope.filter = Object.assign($scope.filter, payload);
  });
  $scope.return = function () {
    //
    $state.go($stateParams.return, $stateParams.backParams);
  };
  console.log("Ready index");

  // MessageBus is used here so that the commonFilter module can pick it up once it loads
  messageBus.addMessage("filterDependency-ready", true);
}]);